import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service'; // updated import

@Component({
  selector: 'app-annualstatement-summary',
  templateUrl: './annualstatement-summary.component.html',
  styleUrls: ['./annualstatement-summary.component.scss'],
  standalone: false,
})
export class AnnualstatementSummaryComponent {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  annualStatement: any;
  annualStatementLoaded: boolean = false;
  selectedisoline: number;
  isolines: any[] = [];
  isoline: any;
  selectedLine: string = '';
  aggregateWriteInValue: number;
  annualStatementTotal: number;
  annualstatementlist: any[] = [];
  showAnnualStatementComaprisonInfo: boolean = false;
  constructor(
    private readonly submissionSummaryService: SubmissionSummaryService, // updated injection
    private readonly router: Router
  ) {}
  ngOnInit(): void {
    this.loadAnnualStatementreport();
    this.getAnualStatement();
    this.getIsoLines();
  }
  getAnualStatement() {
    this.submissionSummaryService
      .getAnnualStatement(this.currentYear, this.prfNumber)
      .subscribe({
        next: (mappingDetails) => {
          if (mappingDetails) {
            this.annualStatement = mappingDetails;
            this.annualStatementLoaded = true;
            console.log('annualStatement', this.annualStatement);
          }
        },
        error: (error) => {
          this.annualStatementLoaded = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
  getIsoLines() {
    this.submissionSummaryService
      .getIsoLines(this.currentYear, this.prfNumber)
      .subscribe({
        next: (isolineslist) => {
          if (isolineslist) {
            this.isoline = this.submissionSummaryService.getSelectedIsoLine(isolineslist);
            console.log('isolines', this.isoline);
          }
        },
        error: (error) => {
          this.router.navigate(['/apifailure']);
        },
      });
  }
  is_aggwn_label(text) {
    return (
      text.trim().toLowerCase().replace(' ', '').replace('-', '') ==
      'aggregatewriteins'
    );
  }
  loadAnnualStatementreport() {
    this.annualstatementlist = [];
    this.submissionSummaryService
      .loadAnnualStatementComparison(
        this.currentYear,
        this.groupCode,
        this.prfNumber
      )
      .subscribe({
        next: (ascomparisondata) => {
          if (ascomparisondata) {
            this.annualstatementlist = ascomparisondata;
            console.log('annualstatementlist1', this.annualstatementlist);
            this.annualstatementlist = this.annualstatementlist.filter(
              (item) => !(item.col1 === 0 && item.col2 === 0)
            );
            console.log('annualstatementlist2', this.annualstatementlist);
            if (this.annualstatementlist.length !== 1) {
              this.showAnnualStatementComaprisonInfo = true;
            }
          }
        },
        error: (error) => {
          this.showAnnualStatementComaprisonInfo = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
  navigateToAnnualStatementComparison() {
    this.router.navigate([
      `/${this.currentYear}/${encodeURIComponent(
        this.prfNumber
      )}/annualstatementcomparison`,
    ]);
  }
}
